<mat-toolbar class="mat-primary">
  <span fxFlex>{{ inputData.areaDisplayName }}</span>
  <mat-icon class="cursor-mat-element" (click)="cancel()">close</mat-icon>
</mat-toolbar>
<mat-dialog-content>
  <div fxLayout="row" fxLayoutAlign="start center">
    <table mat-table [dataSource]="dataSourceList" class="mat-elevation-z8" fxFlex="100">
      <ng-container matColumnDef="user">
        <th mat-header-cell *matHeaderCellDef>Benutzer</th>
        <td mat-cell *matCellDef="let element">
          {{ element.contactData.firstName }} {{ element.contactData.lastName }}
          <small>{{ element.mail }}</small>
        </td>
      </ng-container>

      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef>Aktion</th>
        <td mat-cell *matCellDef="let element">
          <div class="action-buttons">
            <button
              mat-stroked-button
              color="primary"
              title="Inbetriebnahme anlegen"
              (click)="newCommissioningWithoutPass(element)">
              <mat-icon>add</mat-icon>
              Inbetriebnahme beantragen
            </button>
          </div>
        </td>
      </ng-container>

      <!-- Header -->
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>
</mat-dialog-content>
